import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AIChatBot from "./components/AIChatBot";
import CookieConsent from "./components/CookieConsent";
import DataEditor from "./components/DataEditor";

// Import Page Components
import Home from "./pages/Home";
import CV from "./pages/CV";
import Publication from "./pages/Publication";

const AppLayout = () => {
  const location = useLocation();
  const isPublicationPage = location.pathname === "/publication";

  return (
    <div className="flex flex-col min-h-screen">
      {!isPublicationPage && <Navbar />}

      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/publication" element={<Publication />} />
          <Route path="/admin" element={<DataEditor />} />
        </Routes>
      </div>

      {!isPublicationPage && <AIChatBot />}
      {!isPublicationPage && <Footer />}
      <CookieConsent />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
};

export default App;
